import { Timestamp } from 'src/types/utilityTypes';
import api from 'src/utils/ajax';
import { camelcaseKeys } from 'src/utils/camelize-keys';

interface HelloBar {
  active: boolean;
  message: string;
  alwaysShow: boolean;
  updatedAt: Timestamp;
}

export const fetchHelloBar = async (): Promise<HelloBar> => {
  const response = await api.get(`/api/v4/hello_bars/`);

  return camelcaseKeys(response.data) as HelloBar;
};

export const saveHelloBar = async (
  helloBar: Partial<HelloBar>
): Promise<HelloBar> => {
  const response = await api.post('/api/v4/hello_bars/', {
    active: helloBar.active,
    message: helloBar.message,
  });

  return camelcaseKeys(response.data) as HelloBar;
};
